import { apiCall } from "./auth";
import { API_URL } from "./config";


export const getallbuildStations = () => apiCall(`${API_URL}buildstations/getallbuildStations`, "GET",)
export const getsinglebuildStations = (data) => apiCall(`${API_URL}buildstations/getsinglebuildStations`, "POST",data)
export const upatebuildStationStatus = (data) => apiCall(`${API_URL}buildstations/upatebuildStationStatus`, "POST",data)
export const assignpickupstation = (data) => apiCall(`${API_URL}buildstations/assignpickupstation`, "POST",data)
export const upatebuildStatus = (data) => apiCall(`${API_URL}buildstations/upatebuildStatus`, "POST",data)
export const getbuildStationsfilter = (data) => apiCall(`${API_URL}buildstations/getbuildStationsfilter`, "POST",data)
export const dropdownfilter = (data) => apiCall(`${API_URL}buildstations/dropdownfilter`, "POST",data)
export const pickUpdownfilter = (data) => apiCall(`${API_URL}buildstations/pickUpdownfilter`, "POST",data)
export const getbuilderlist = () => apiCall(`${API_URL}buildstations/getbuilderlist`, "GET")
export const getbuildStationsbuilder = (data) => apiCall(`${API_URL}buildstations/getbuildStationsbuilder`, "POST",data);
export const getsinglebuilstation = (data) => apiCall(`${API_URL}buildstations/getsinglebuilstation`, "POST",data);
export const upatebuildStationbuilderSatgeStatus = (data) => apiCall(`${API_URL}buildstations/upatebuildStationbuilderSatgeStatus`, "POST",data);
export const getbuildsingleStationsbuilder = (data) => apiCall(`${API_URL}buildstations/getbuildsingleStationsbuilder`, "POST",data);



//shipStations
export const getallshipStations = () => apiCall(`${API_URL}shipstations/getallshipStations`, "GET")
export const getallpickupStations = () => apiCall(`${API_URL}shipstations/getallpickupStations`, "GET")
export const getsingleShipStations = (data) => apiCall(`${API_URL}shipstations/getsingleShipStations`, "POST",data)
export const getsinglepickupStations = (data) => apiCall(`${API_URL}shipstations/getsinglepickupStations`, "POST",data)
export const upateshipstationstatus = (data) => apiCall(`${API_URL}shipstations/upateshipstationstatus`, "POST",data)
export const updatepickupstationstatus = (data) => apiCall(`${API_URL}shipstations/updatepickupstationstatus`, "POST",data)
